
import { Placement } from '@post-office/placements-frontend/attachment-consolidation-add-create';
export default Placement;
